import React from "react";
import { label } from "../../../config";
import SearchInput from "./SearchInput";
import TabContent from "./TabContent";
import ChipsVariableItem from "./ChipsVariableItem";

/**
 * ChipsTab component for rendering the chips tab content
 * @author Muskan Thakur
 */
const ChipsTab = ({
  filteredChips,
  chipsSearchText,
  setChipsSearchText,
  smartChipClickHandler,
  containerRef,
  handleKeyDown,
}) => {
  const chips = filteredChips || [];

  return (
    <>
      <SearchInput
        placeholder={label.SEARCH_CHIPS}
        value={chipsSearchText}
        onChange={(e) => setChipsSearchText(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <TabContent containerRef={containerRef}>
        {chips.length === 0 ? (
          <div className='no-result'>{label.NO_REUSABLE_CHIPS}</div>
        ) : (
          chips.map((variable) => (
            <ChipsVariableItem
              key={variable?.id}
              variable={variable}
              onClick={() => smartChipClickHandler(variable)}
            />
          ))
        )}
      </TabContent>
    </>
  );
};

export default React.memo(ChipsTab);
